import * as _ from "lodash";
import * as React from "react";

import {
    acceptDocumentName,
    acceptDocumentType,
} from "../../../Helpers/documents";
import { moveCaretAtEnd } from "../../../Helpers/forms";
import * as Models from "../../../Models";
import FileTypeSelect from "./FileTypeSelect";

interface DocumentsCardReadySendProps {
    document: Models.DocumentLinkUpload;
    detail: Models.SiteDetail;
    isUploading: boolean;
    // serviceVisitReportFileTypes?: Models.ServiceVisitReportFileType[];

    updateFileToReadySendState: (Document: Models.DocumentLinkUpload) => any;
    uploadLinkDocument?: (document: Models.DocumentLinkUpload) => any;
    removeLinkDocumentFromReadySendState?: (name: string) => any;
}

const DocumentsCardReadySend: React.FC<DocumentsCardReadySendProps> = (
    props: DocumentsCardReadySendProps
) => {
    const updateName: Function = (fileName: string): void => {
        props.updateFileToReadySendState(
            _.merge({}, props.document, { fileName })
        );
    };
    const debouncedUpdateName: Function = _.debounce(updateName, 250);
    const isAcceptedFileName: boolean = acceptDocumentName(
        props.document.fileName
    );
    const isAcceptedFileNameHide: string = isAcceptedFileName ? "--hide" : "";
    const fileErrorText: string = !isAcceptedFileName
        ? props.document.fileName.length === 0
            ? `Can't be empty`
            : "Illegal characters"
        : "";
    const disabled: boolean =
        !acceptDocumentType(props.document.metaData.documentType) ||
        !isAcceptedFileName;

    return (
        <div
            className={`DocumentCardReadySend ${
                props.isUploading ? "d-none" : ""
            }`}
        >
            <span className="DocumentCardReadySend__header">File details</span>

            <div className="form-group">
                <label className="tiny">Confirm or change file name:</label>

                <input
                    autoFocus
                    onFocus={(e) => moveCaretAtEnd(e)}
                    className="form-control"
                    onChange={(e) => debouncedUpdateName(e.target.value)}
                    defaultValue={props.document.fileName}
                />
                <span
                    className={`DocumentCardReadySend__illegal-characters-text${isAcceptedFileNameHide}`}
                >
                    {fileErrorText}
                </span>
            </div>

            <div className="form-group">
                <label className="tiny required">Document type:</label>

                <div className="dropdown DocumentCardReadySend__list-documenttype">
                    <FileTypeSelect
                        document={props.document}
                        updateFileToReadySendState={
                            props.updateFileToReadySendState
                        }
                    />
                </div>
            </div>

            <div className="form-group">
                <label className="tiny">Site ID:</label>
                <input
                    readOnly
                    className="form-control"
                    value={props.detail.siteName}
                />
            </div>

            <div className="form-group">
                <label className="tiny">Functional location:</label>
                <input
                    readOnly
                    className="form-control"
                    value={props.detail.description}
                />
            </div>

            <div className="DocumentCardReadySend__confirmButtons">
                <button
                    className="btn btn-secondary DocumentCardReadySend__confirm-button"
                    onClick={(e) =>
                        props.removeLinkDocumentFromReadySendState(
                            `${props.document.fileName}.${props.document.filetype}`
                        )
                    }
                >
                    Cancel
                </button>

                <button
                    className="btn btn-primary float-end DocumentCardReadySend__confirm-button"
                    onClick={(e) => props.uploadLinkDocument(props.document)}
                    disabled={disabled}
                >
                    Send
                </button>
            </div>
        </div>
    );
};

export default DocumentsCardReadySend;
